function apiBaseUrl() {
  return process.env.REACT_APP_IE_API_BASE_URL;
}

export function alerts() {
  return `${apiBaseUrl()}/project_finder/alerts`
}

export function updateAlert(id) {
  return `${apiBaseUrl()}/project_finder/alerts/${id}`
}



// WEBPACK FOOTER //
// ./src/features/alertsManager/apiUrls.js